// extracted by mini-css-extract-plugin
export default {"headingWrap":"NvSignUp_headingWrap__jrn8a","headingTitle":"NvSignUp_headingTitle__jo+uD","headingVector":"NvSignUp_headingVector__wATJo"};